<form
  class="form"
  [formGroup]="form"
  class="form-container"
  (ngSubmit)="save()"
  *ngIf="form"
>
  <h3 *ngIf="editionId === 'new'">Nova Edição</h3>
  <h3 *ngIf="editionId !== 'new'">Aterar Edição</h3>
  <p-panel header="Edição">
    <div class="form-field">
      <label for="editionTheme">Tema (obrigatório)</label>
      <input
        id="editionTheme"
        type="text"
        pInputText
        formControlName="editionTheme"
      />
    </div>
    <div class="form-field">
      <label for="editionDate">Mes de vigência (obrigatório)</label>
      <p-calendar
        view="month"
        formControlName="editionDateTime"
        dateFormat="yy.mm"
        id="editionDate"
      />
    </div>
  </p-panel>

  <p-panel
    header="Ícones das assinaturas - Máx 100kb | WEBP | Dimensão base: 70x70"
  >
    <div formArrayName="icons">
      <div *ngFor="let icon of icons.controls; let index = index">
        <p-fileUpload
          mode="basic"
          [chooseLabel]="getEditionName(index)"
          name="file"
          [auto]="true"
          [customUpload]="true"
          (onSelect)="
            upload(
              $event,
              'icons.' + index + '.icon',
              70,
              70,
              100 * 1024,
              fileUploadIcon
            )
          "
          accept="image/webp, image/gif"
          [maxFileSize]="1024000"
          uploadIcon="pi pi-file"
          [id]="'fileUploadIcon' + index"
          #fileUploadIcon
        />
        <div class="form-container__img">
          <img [src]="getEditionIcon(index)?.value?.icon" />
        </div>
      </div>
    </div>
  </p-panel>

  <p-panel
    header="Cards da edição - Máx (120kb - 170kb)  | WEBP | Dimensão base: (345x104 - 488x109)"
  >
    <div class="form-field">
      <p-fileUpload
        mode="basic"
        [chooseLabel]="'Card da edição desktop'"
        name="file"
        [auto]="true"
        [customUpload]="true"
        (onSelect)="
          upload(
            $event,
            'editionCardDesktop',
            488,
            109,
            170 * 1024,
            fileUploadCD
          )
        "
        accept="image/webp, image/gif"
        [maxFileSize]="174080"
        uploadIcon="pi pi-file"
        id="fileUploadCD"
        #fileUploadCD
      />
      <div class="form-container__img">
        <img [src]="form.get('editionCardDesktop').value" />
      </div>
    </div>
    <div class="form-field">
      <p-fileUpload
        mode="basic"
        [chooseLabel]="'Card da edição mobile'"
        name="file"
        [auto]="true"
        [customUpload]="true"
        (onSelect)="
          upload(
            $event,
            'editionCardMobile',
            345,
            104,
            120 * 1024,
            fileUploadCM
          )
        "
        accept="image/webp, image/gif"
        [maxFileSize]="122880"
        uploadIcon="pi pi-file"
        id="fileUploadCM"
        #fileUploadCM
      />
      <div class="form-container__img">
        <img [src]="form.get('editionCardMobile').value" />
      </div>
    </div>
    <div class="form-field">
      <label>
        Cor do fundo do card
        <small>Apenas caso não tenha imagem cadastrada</small>
      </label>
      <p-colorPicker formControlName="editionCardBackgroundColor" />
    </div>
  </p-panel>

  <p-panel
    header="Card para o carrossel de últimas edições - Máx 170kb | WEBP | Dimensão base: 280x396"
  >
    <div class="form-field">
      <span class="label-container">
        <label>Alt text - máx. 125 caracteres</label>
      </span>
      <input
        id="lastEditionsCarouselCardAlt"
        type="text"
        pInputText
        formControlName="lastEditionsCarouselCardAlt"
      />
    </div>
    <div class="form-field">
      <p-fileUpload
        mode="basic"
        [chooseLabel]="'Últimas edições'"
        name="file"
        [auto]="true"
        [customUpload]="true"
        (onSelect)="
          upload(
            $event,
            'lastEditionsCarouselCard',
            280,
            396,
            170 * 1024,
            fileUploadLast
          )
        "
        accept="image/webp, image/gif"
        [maxFileSize]="174080"
        uploadIcon="pi pi-file"
        id="fileUploadLast"
        #fileUploadLast
      />
      <div class="form-container__img">
        <img [src]="form.get('lastEditionsCarouselCard').value" />
      </div>
    </div>
  </p-panel>

  <p-panel header="Vídeo da edição - MP4 | Poster - PNG ou JPG">
    <div class="form-field">
      <p-fileUpload
        mode="basic"
        chooseLabel="Upload do vídeo"
        name="file"
        [auto]="true"
        [customUpload]="true"
        (onSelect)="uploadEditionVideo($event, fileUploadVideo)"
        accept="video/mp4"
        uploadIcon="pi pi-file"
        id="fileUploadVideo"
        #fileUploadVideo
      />
      <div class="form-container__preview" *ngIf="form.value.videoUrl">
        <video
          controls
          [src]="form.value.videoUrl"
          class="form-container__video"
        >
          Não foi possível carregar a prévia do vídeo
        </video>
      </div>
    </div>
    <div class="form-field">
      <p-fileUpload
        mode="basic"
        chooseLabel="Upload do poster"
        name="file"
        [auto]="true"
        [customUpload]="true"
        (onSelect)="uploadEditionPoster($event, fileUploadPoster)"
        accept="image/png,image/jpeg"
        uploadIcon="pi pi-file"
        id="fileUploadPoster"
        #fileUploadPoster
      />
      <div class="form-container__preview" *ngIf="form.value.posterUrl">
        <img
          [src]="form.value.posterUrl"
          alt="Poster da edição"
          class="form-container__poster"
        />
      </div>
    </div>
  </p-panel>

  <div class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      [routerLink]="['/configuracoes/editions']"
      [queryParams]="{ businessUnitId: businessUnitId }"
    />
    <p-button label="Salvar" type="submit" [disabled]="form.invalid" />
  </div>
</form>
<p-toast />
